import React from 'react';
import GithubSvg from '../assets/github-mark-white.svg'

function About() {
  return (
    <section id="about" className="bg-gray-100 py-16">
      <div className="container mx-auto px-4">
        <h2 className="text-3xl font-bold text-center mb-8">About Me</h2>
        <div className="max-w-3xl mx-auto">
          <p className="text-lg text-gray-700 leading-relaxed">
            Hi! My name is Łukasz Mrowiec. I'm an 19-year-old IT Student at Technical secondary school in Poland.
          </p>
          <p className="text-lg text-gray-700 leading-relaxed mt-4">
          I'm looking for work in the IT industry. I'm self-taught, I've learned everything I know on my own. I am passionate about programming. With great pleasure I improve my qualifications and I want to buy new ones Experience. All my projects are on my GitHub profile.
          </p>
        </div>

        <div className="flex space-x-4 justify-center align-middle mt-4">
            <a href="https://github.com/Lukeuke" className="hover:text-gray-400 text-center text-black" target='_blank' rel="noreferrer">
                <img src={GithubSvg} alt='Github' title='Github' className='w-9' />
            </a>
        </div>
      </div>
    </section>
  );
}

export default About;